/**
 * @see https://loiane.com/2017/08/angular-tips-formatting-dates-with-a-custom-date-pipe-dd-mm-yyyy/
 *
 * This is a custom Date pipe
 *
 */

// Core packages
import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

// Third party packages
import moment from 'moment';

// Custom packages
import { ConfigService } from "../services/config.service";

/**
 * Date only format
 */
@Pipe({
  name: "timeFormat",
})
export class TimeFormatPipe extends DatePipe implements PipeTransform {
  constructor(private configService: ConfigService) {
    super("en-US");
  }

  transform(value: any, args?: any): any {
    // return super.transform(value, Constants.DATE_FMT);
    return super.transform(value, this.configService.timeFormat);
  }
}

/**
 * Date only format
 */
@Pipe({
  name: "dateFormat",
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
  constructor(private configService: ConfigService) {
    super("en-US");
  }

  transform(value: any, args?: any): any {
    // return super.transform(value, Constants.DATE_FMT);
    return super.transform(value, this.configService.dateFormat);
  }
}

/**
 * Date + time format
 */
@Pipe({
  name: "dateTimeFormat",
})
export class DateTimeFormatPipe extends DatePipe implements PipeTransform {
  constructor(private configService: ConfigService) {
    super("en-US");
  }

  transform(value: any, args?: any): any {
    // return super.transform(value, Constants.DATE_TIME_FMT);
    return super.transform(value, this.configService.dateTimeFormat);
  }
}

/**
 * Date document format:
 */
@Pipe({
  name: "dateDocumentFormat",
})
export class DateDocumentFormatPipe extends DatePipe implements PipeTransform {
  constructor(private configService: ConfigService) {
    super("it-It");
  }

  transform(value: any, args?: any): any {
    // return super.transform(value, Constants.DATE_TIME_FMT);
    let transformDate = value;
    if (RegExp(/[0-9]{4}-[0-9]{2}-[0-9]{2}/, "i").test(value) && moment(value).isValid()) {
      transformDate = super.transform(value);
    }
    return transformDate;
  }
}

/**
 * Date document format:
 */
@Pipe({
  name: "minutesToHoursFormat",
})
export class MinutesToHoursPipe implements PipeTransform {
  transform(value: number, args?: any): string {
    const hours = Math.floor(value / 60);
    const minutes = Math.floor(value % 60);
    return `${hours}h ${minutes}m`;
  }
}
